import {
  RangeDatePicker,
  type FocusState,
  type RangeDatePickerProperties,
} from "@jetblue/kit/date-picker/range";
import { useState } from "react";
import { useBestFaresRenderDate } from "./render-date";
import type { BestFaresCalendarQueryInput } from "../../hooks/use-best-fares-calendar";

export type BestFaresRangeDatePickerProperties = Pick<
  RangeDatePickerProperties,
  | "departIsRequired"
  | "endDate"
  | "labels"
  | "returnIsRequired"
  | "selectedDates"
  | "setSelectedDates"
  | "showValidation"
  | "startDate"
> &
  BestFaresCalendarQueryInput & {
    showDatePickerPricing: boolean;
  };
export const BestFaresRangeDatePicker = ({
  destination,
  origin,
  passengers,
  showDatePickerPricing,
  usePoints,
  ...rangeDatePickerProperties
}: BestFaresRangeDatePickerProperties) => {
  const { endDate, startDate } = rangeDatePickerProperties;
  const [focusState, setFocusState] = useState<FocusState>("none");
  const renderDate = useBestFaresRenderDate({
    destination,
    endDate,
    fareDirection: focusState === "end" ? "inbound" : "outbound",
    origin,
    passengers,
    showDatePickerPricing,
    startDate,
    tripType: "round-trip",
    usePoints,
  });

  return (
    <RangeDatePicker
      {...rangeDatePickerProperties}
      onFocusStateChange={setFocusState}
      renderDate={renderDate}
    />
  );
};
